<template>
  <div>
    <paginated-table
      id="admin-invoices-table"
      endpoint="invoices"
      :columns="columns"
      :label="$tc('invoices.invoice', 2)"
      row-link
      :show-action-column="false"
      @filters-changed="setInvoiceFilters"
    >
      <template #cell(paid_at)="{ item }">
        {{ item.paid_at ? "✓" : "✗" }}
      </template>

      <template #cell(user.full_name)="{ item }">
        <span :class="`${!item.user ? 'text-grey' : ''}`">
          {{ item.user?.full_name ?? $t("views.admin.invoices.user_deleted") }}
        </span>
      </template>
    </paginated-table>
  </div>
</template>

<script>
import PaginatedTable from "@/components/shared/PaginatedTable.vue";
import { Column } from "@/components/shared/PaginatedTableColumns";

export default {
  name: "AdminInvoices",
  components: {
    PaginatedTable,
  },
  data() {
    return {
      filters: {},
      columns: [
        Column.withoutFilter("id", this.$t("lists.id"), "id", { showByDefault: false }),
        Column.withRelation(
          "user.full_name",
          this.$t("users.fields.user"),
          {
            relation: "users",
            label: "full_name",
            field: "id",
          },
          "user_id"
        ),
        new Column("period", this.$t("views.admin.invoices.columns.name"), "text"),
        new Column("created_at", this.$t("views.admin.invoices.columns.date"), "date"),
        new Column("total", this.$t("views.admin.invoices.columns.total"), "currency"),
        new Column(
          "total_with_taxes",
          this.$t("views.admin.invoices.columns.total_with_taxes"),
          "currency"
        ),
      ],
    };
  },
  methods: {
    setInvoiceFilters(invoiceFilters) {
      const newFilters = {};
      for (const invoiceFilter in invoiceFilters) {
        newFilters["invoice." + invoiceFilter] = invoiceFilters[invoiceFilter];
      }

      this.filters = newFilters;
    },
  },
};
</script>

<style lang="scss"></style>
